import React from "react";

import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { Checkbox, ListItemText } from "@material-ui/core";
import { i18n } from "../../translate/i18n";

export const NO_QUEUE_FILTER_ID = -1;

const TicketsQueueSelect = ({
	userQueues,
	selectedQueueIds = [],
	onChange,
	style,
}) => {
	const handleChange = e => {
		const values = Array.isArray(e.target.value) ? e.target.value : [];
		onChange(values.map(value => Number(value)).filter(value => !Number.isNaN(value)));
	};

	return (
		<div style={{ width: "100%", marginTop: -4, ...style }}>
			<FormControl fullWidth margin="dense">
				<Select
					multiple
					displayEmpty
					variant="outlined"
					value={selectedQueueIds}
					onChange={handleChange}
					MenuProps={{
						anchorOrigin: {
							vertical: "bottom",
							horizontal: "left",
						},
						transformOrigin: {
							vertical: "top",
							horizontal: "left",
						},
						getContentAnchorEl: null,
					}}
					renderValue={() => i18n.t("ticketsQueueSelect.placeholder")}
				>
					<MenuItem dense value={NO_QUEUE_FILTER_ID}>
						<Checkbox
							size="small"
							color="primary"
							checked={selectedQueueIds.indexOf(NO_QUEUE_FILTER_ID) > -1}
						/>
						<ListItemText primary={i18n.t("ticketsQueueSelect.noQueue")} />
					</MenuItem>
					{userQueues?.length > 0 &&
						userQueues.map(queue => (
							<MenuItem dense key={queue.id} value={queue.id}>
								<Checkbox
									style={{
										color: queue.color,
									}}
									size="small"
									color="primary"
									checked={selectedQueueIds.indexOf(queue.id) > -1}
								/>
								<ListItemText primary={queue.name} />
							</MenuItem>
						))}
				</Select>
			</FormControl>
		</div>
	);
};

export default TicketsQueueSelect;
